module.exports = __webpack_public_path__ + "img/gallery-4.4af2ad95.jpg";